import { createFileRoute } from '@tanstack/react-router'
import { ScReportsPage } from '@/features/support-coordination/reports'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/reports',
)({
  component: ScReportsPage,
})
